'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import FeaturesModal from 'ui-addon-upgrades/_core/features/FeaturesModal';
import FeaturesProvider from 'ui-addon-upgrades/_core/features/FeaturesProvider';
import { getAllFeaturesByAllProductLinesSelector } from '../../../selectors/FeatureSelectors';

const FeatureModalFS = ({
  highlightedProducts,
  onCloseClick,
  productLine,
  defaultProductLevel
}) => {
  const passedInFeatures = useSelector(getAllFeaturesByAllProductLinesSelector);
  return /*#__PURE__*/_jsx(FeaturesProvider, {
    highlightedProducts: highlightedProducts,
    productLine: productLine,
    passedInFeatures: passedInFeatures,
    children: /*#__PURE__*/_jsx(FeaturesModal, {
      onCloseClick: onCloseClick,
      productLine: productLine,
      defaultProductLevel: defaultProductLevel
    })
  });
};

export default FeatureModalFS;